var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("sticky", { on: { scrolled: _vm.setPinnedStatus } }, [
    _c(
      "div",
      {
        ref: "container",
        staticClass: "main-menu-container fixed-top",
        class: { "is-transparent": _vm.isTransparent }
      },
      [
        _c(
          "nav",
          {
            staticClass: "navbar navbar-expand-lg",
            attrs: { id: "main-menu" }
          },
          [
            _vm._t("home_link", null, { logoUri: _vm.logoUri }),
            _vm._v(" "),
            _vm.config_header.multilanguage
              ? _c("multi-language", {
                  attrs: { languages: _vm.config_header.multilanguage }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "navbar-toggler",
                attrs: {
                  type: "button",
                  "data-toggle": "collapse",
                  "aria-expanded": "false",
                  "aria-label": _vm.lang.labels.toggle
                },
                on: { click: _vm.toggle }
              },
              [
                _c("masked-image", {
                  attrs: { src: "/img/icons/menu-toggle.svg" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "collapse navbar-collapse",
                class: { show: _vm.active }
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "button",
                      { staticClass: "close-menu", on: { click: _vm.toggle } },
                      [
                        _c("img", {
                          attrs: {
                            src: "/img/icons/close.svg",
                            alt: "Chiudi menu",
                            height: "20",
                            width: "20"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _vm._t("links")
                  ],
                  2
                )
              ]
            )
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }